import React from "react";
import PlatformAnalyticsExperience from "./PlatformAnalyticsExperience";

/*
 * Google Search Analytics — served by the redesigned Platform Analytics
 * Experience (Cross-Platform Analytics design-system adoption). The route,
 * page title, report-link contract, and topline data contract are unchanged;
 * the profile lives in src/platformAnalytics/platformAnalyticsProfiles.js.
 */
export default function GoogleAnalytics() {
  return <PlatformAnalyticsExperience platformKey="google_search" />;
}
